// Note: we use the ngx-currency for all numeric form fields, not just currency fields
// it offers validation/limits of numeric inputs useful for non-currency use cases as well as currency
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';

export const customCurrencyMaskConfig: NgxCurrencyConfig = {
    align: 'left',
    allowNegative: false,
    allowZero: true,
    decimal: '.',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: ',',
    nullable: true,
    min: undefined,
    max: undefined,
    inputMode: NgxCurrencyInputMode.Natural,
};

export const currencyMaskNumberConfigOverride: Partial<NgxCurrencyConfig> = {
    thousands: ',',
    decimal: '',
    precision: 0,
    inputMode: NgxCurrencyInputMode.Natural,
    allowNegative: true,
};

export const integerMaskNumberConfigOverride: Partial<NgxCurrencyConfig> = {
    align: 'left',
    thousands: ',',
    decimal: '',
    precision: 0,
    inputMode: NgxCurrencyInputMode.Financial,
    allowNegative: true,
};

export const decimalMaskNumberConfigOverride: Partial<NgxCurrencyConfig> = {
    align: 'left',
    thousands: ',',
    decimal: '.',
    precision: 2,
    // Need to use Financial mode for normal decimals as there is a bug with Natural mode where entering negative numbers
    // has terrible UX, see: https://github.com/nbfontana/ngx-currency/issues/97
    inputMode: NgxCurrencyInputMode.Financial,
    allowNegative: true,
};
